module.exports = __webpack_public_path__ + "static/img/env-ribbon-tag-right.ac5fe345.svg";